export default __webpack_public_path__ + "static/media/flechaDir.57001c6d.png";